// Generated by LiveScript 1.5.0
var base, classnames;
base = require('./base');
classnames = require('classnames/bind');
module.exports = function(styles){
  return base(classnames.bind(styles));
};